export default __webpack_public_path__ + "static/Logo_MB_new-4800887d092364583ae44cc94dae19ef.png";